import { render } from "./Policy.vue?vue&type=template&id=4b0dd364&scoped=true"
const script = {}

import "./Policy.vue?vue&type=style&index=0&id=4b0dd364&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0dd364"]])

export default __exports__